import AppConfig from '../config/AppConfig';
import * as cryptoJS from 'crypto-js';
import * as R from 'ramda';
import * as Immutable from 'seamless-immutable';
import { mblViewTables, mblViewTable } from '../components/dashboard/IDashboard';
import { store } from '../redux/store';
import { ICalendarCategory } from 'redux/sagaUser/ISagaUser';
import * as moment from 'moment';
import { IDropdownData, IAdvanceSearchOutput } from 'redux/utility/IAdvanceSearch';
import { EPropertyListType, Property, VideoLink, SelectedPortalProperty, PropertyFile } from 'redux/sagaProperty/ISagaProperty';
import { PictureDetail } from 'redux/sagaProject/IProjectDetail';
import { IGalleryImage } from '../components/react-grid-gallery/Gallery';
import Resizer from 'react-image-file-resizer';
import { MAX_WIDTH, MAX_HEIGHT } from '../config/imageConstant';

export function getView(width) {
    let newView = 'MobileView';
    if (width > 1220) {
        newView = 'DesktopView';
    } else if (width > 767) {
        newView = 'TabView';
    }
    return newView;
}

/**
 * This function searches for Object in any array of object containing a mathcing key.
 * The key can be case insensitive
 * @param {Array<Object>} objectArray
 */
export function searchInObjectArrayCaseInsentitive(objectArray, key, value) {
    let result = null;
    if (objectArray && objectArray.length > 0) {
        objectArray.forEach((item) => {
            // const eqInsensitive = R.curry((a, b) => String(a).toLowerCase() === String(b).toLowerCase());
            // result = R.find(R.propSatisfies(eqInsensitive( item[key], value)))(objectArray);
            if (String(item[key]).toLowerCase() === String(value).toLocaleLowerCase()) {
                result = item;
            }
        });
    }
    return result;
}

export function getSubdomain(): string {
    return window.location.host.split('.')[0];
}

/**
 * Synchronously retrieves a state variable from one of the stores, like : SagaAuth.currentOffice
 * @param storeName one of the store names from redux/index.js , like SagaAuth, SagaOffer
 * @param stateVariableName variable name inside the store, like currentOffice
 */
export function getStateItem(storeName, stateVariableName) {
    const storeObj = store.getState()[storeName];
    if (storeObj) {
        return storeObj[stateVariableName];
    }
    else {
        console.warn('[GET_STORE_ITEM] store ' + storeName + ' does not exist??');
    }
}

/**
 * Returns the redirection path that contains the office and language element
 * @param path
 * @returns {string}
 */
export function buildUrl(path: string): string {
    if (path.trim()[0] === '/') { // remove starting slash
        path = path.trim().substr(1);
    }
    const currentPathArr = getCurrentPath().split('/');
    return '/' + [currentPathArr[0] /*this is office*/, currentPathArr[1] /*this is language*/, path].join('/');
}

/**
 * Returns the root url . this method ALWAYS adds a trailing slash at the end of the document
 * @returns {string}
 */
export function getDocumentRoot(): string {
    let url: string;
    if (process.env.PUBLIC_URL) {
        url = process.env.PUBLIC_URL;
    }
    else {
        const arr = window.location.href.split('/');
        url = arr[0] + '//' + arr[2];
    }
    if (url.slice(-1) !== '/') {
        url += '/';
    }// add a trailing slash
    return url;

}

export function sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
}


export function timeDifference(givenTime) {
    givenTime = new Date(givenTime);
    const milliseconds = new Date().getTime() - givenTime.getTime();
    const numberEnding = endingNumber => {
        return endingNumber > 1
            ? 's'
            : '';
    };
    const num = num => num > 9
        ? '' + num
        : '0' + num;
    const getTime = () => {
        let temp = Math.floor(milliseconds / 1000);
        const years = Math.floor(temp / 31536000);
        if (years) {
            const month = num(givenTime.getUTCMonth() + 1);
            const day = num(givenTime.getUTCDate());
            const year = givenTime.getUTCFullYear() % 100;
            return `${day}-${month}-${year}`;
        }
        const days = Math.floor((temp %= 31536000) / 86400);
        if (days) {
            if (days < 28) {
                return days + ' day' + numberEnding(days);
            } else {
                const months = [
                    'Jan',
                    'Feb',
                    'Mar',
                    'Apr',
                    'May',
                    'Jun',
                    'Jul',
                    'Aug',
                    'Sep',
                    'Oct',
                    'Nov',
                    'Dec'
                ];
                const month = months[givenTime.getUTCMonth()];
                const day = num(givenTime.getUTCDate());
                return `${day} ${month}`;
            }
        }
        const hours = Math.floor((temp %= 86400) / 3600);
        if (hours) {
            return `${hours} hour${numberEnding(hours)} ago`;
        }
        const minutes = Math.floor((temp %= 3600) / 60);
        if (minutes) {
            return `${minutes} minute${numberEnding(minutes)} ago`;
        }
        return 'a few seconds ago';
    };
    return getTime();
}

export function getUnixTimestampInSeconds(): number {
    return + Date.now();
}


export function getDistinctFetureTypes(projectFeature, province, district, isShowAllTransport) {
    if (!projectFeature || projectFeature === undefined) { return null; }
    // get distinct type of feature
    let distinctFeatureTypes = projectFeature.map((item) => {
        return item.type;
    });
    distinctFeatureTypes = R.uniq(distinctFeatureTypes);
    distinctFeatureTypes = distinctFeatureTypes.map((df) => {
        return {
            typeName: df,
            features: []
        };
    });
    projectFeature.forEach((item) => {
        const i = R.findIndex(R.propEq('typeName', item.type))(distinctFeatureTypes);
        /*
            if type is not transportation 
                or (isShowAllTransport is null or true )
                or item.provice and item.district are null 
            then add all feature data
         */
        if (((item.districtCode === null && item.provinceCode === null)
            || (isShowAllTransport || isShowAllTransport === null || isShowAllTransport === true)
            || (item.type !== 'Transportation' && item.type !== 'การคมนาคม' && item.type !== 'Almenningssamgöngur')
        )) {
            distinctFeatureTypes[i].features.push(item);
        } else {
            if (item.districtCode !== null && district === item.districtCode) {
                distinctFeatureTypes[i].features.push(item);
            } else if (item.provinceCode !== null
                && province === item.provinceCode
                && item.districtCode !== null
                && (!district || district === null || district === '' || district === '0')
            ) {
                distinctFeatureTypes[i].features.push(item);
            }
        }
    });
    return distinctFeatureTypes;
}

export function checkTypeUploadImageFile(file) {
    const isJPG = file.type === 'image/jpeg';
    const isPNG = file.type === 'image/png';
    if (!isJPG && !isPNG) {
        return false;
    }
    return isJPG || isPNG;
}

export function getBase64(img, callback) {
    const reader = new FileReader();
    reader.addEventListener('load', () => callback(reader.result));
    reader.readAsDataURL(img);
}

export function resizeAndGetBase64(img, callback) {
    const i = new Image();
    i.onload = () => {
        // check width, height is exceed max-width, max-height
        if (i.width > MAX_WIDTH || i.height > MAX_HEIGHT) {
            console.log('resize-image');
            Resizer.imageFileResizer(img, MAX_WIDTH, MAX_HEIGHT, 'JPEG', 100, 0, uri => { callback(uri); });
        }
        else {
            getBase64(img, callback);
        }
    };
    i.src = URL.createObjectURL(img);
}

export function getCurrentPath(): string {
    const documentRoot = getDocumentRoot();
    // console.log('documentRoot->',documentRoot );
    const path = window.location.href.replace(documentRoot, '').trim();
    return path;
}

export const currentLocation = (state) => state.router.location;
export const currentState = (state) => state;

export function encrypt(string2Encrypt: string): string {
    const key = cryptoJS.enc.Utf8.parse(AppConfig.sharedKey);
    const iv = cryptoJS.enc.Utf8.parse(AppConfig.sharedIV);
    const encrypted = cryptoJS.AES.encrypt(string2Encrypt, key, {
        // keySize: 128 / 8,
        iv,
        mode: cryptoJS.mode.CBC,
        padding: cryptoJS.pad.Pkcs7
    });
    return encrypted.toString();
}

export function decrypt(string2Decrypt: string): string {
    const key = cryptoJS.enc.Utf8.parse(AppConfig.sharedKey);
    const iv = cryptoJS.enc.Utf8.parse(AppConfig.sharedIV);
    const decrypted = cryptoJS.AES.decrypt(string2Decrypt, key, {
        iv,
        mode: cryptoJS.mode.CBC,
        padding: cryptoJS.pad.Pkcs7
    });
    return decrypted.toString(cryptoJS.enc.Utf8);
}

export function getSagaWAPUrl(action: string, userName: string, password: string, branchId: number, otherParams: any): string {
    const encrypted = encodeURIComponent(encrypt(`${userName}:${password}`));
    const currentOffice = getStateItem('SagaAuth', 'currentOffice');
    const sagaWAPUrl = (currentOffice) ? currentOffice.sagaWAPUrl : '';
    switch (action) {
        case 'propertylist':
            return `${sagaWAPUrl}LandingPage.aspx?q=${encrypted}&returnURL=/Main&type=propertylist&branchId=${branchId}`;
        case 'propertyDetail':
            return `${sagaWAPUrl}LandingPage.aspx?q=${encrypted}&returnURL=/Main/PropertyRoute.ashx?property_id=${otherParams.propertyId}&type=property&branchId=${branchId}`;
        case 'settings':
            if (otherParams.isAdmin) {
                return `${sagaWAPUrl}LandingPage.aspx?q=${encrypted}&returnURL=/Main/Admin/SalesReport.aspx&type=setting&branchId=${branchId}`;
            }
            else {
                return `${sagaWAPUrl}LandingPage.aspx?q=${encrypted}&returnURL=/Main/Default.aspx&type=setting&branchId=${branchId}`;
            }
        case 'salereport':
            if (otherParams.isAdmin) {
                return `${sagaWAPUrl}LandingPage.aspx?q=${encrypted}&returnURL=/Main/Admin/SalesReport.aspx&type=setting&branchId=${branchId}`;
            }
            else {
                return `${sagaWAPUrl}LandingPage.aspx?q=${encrypted}&returnURL=/Main/UserSalesReport/UserSalesReport.aspx&type=setting&branchId=${branchId}`;
            }
        case 'excellist':
            if (otherParams.isAdmin) {
                return `${sagaWAPUrl}LandingPage.aspx?q=${encrypted}&returnURL=/Main/Admin/ExcelList.aspx&type=setting&branchId=${branchId}`;
            }
            else {
                return `${sagaWAPUrl}LandingPage.aspx?q=${encrypted}&returnURL=/Main/UserSalesReport/ExcelList.aspx&type=setting&branchId=${branchId}`;
            }
        case 'offer':
            return `${sagaWAPUrl}Main/Offers/Buyers_SAGAUI.aspx?actionId=${otherParams.actionId}&offerId=${otherParams.offerId}&propertyId=${otherParams.propertyId}&isCreate=false`;
        case 'createoffer':
            return `${sagaWAPUrl}Main/Offers/Buyers_SAGAUI.aspx?propertyId=${otherParams.propertyId}&isCreate=true`;
        case 'contract':
            return `${sagaWAPUrl}Main/Contracts/Buyers_SAGAUI.aspx?contractId=${otherParams.contractId}&offerId=${otherParams.offerId}&propertyId=${otherParams.propertyId}`;
        case 'deed':
            return `${sagaWAPUrl}Main/Deeds/Buyers_SAGAUI.aspx?contractId=${otherParams.contractId}&offerId=${otherParams.offerId}&deedId=${otherParams.deedId}`;
        case 'viewReport':
            return `${sagaWAPUrl}Main/Reports/ReportViewer.aspx?newReport=true&reportName=${otherParams.reportName}&resultURL=${encodeURI(otherParams.resultURL)}`;
        default:
            return '';
    }
}

export function handleOnProjectDetailImageTitleChanged(projectDetail, title2Change, pictureId, pictureType) {
    const projectDetailTab = Immutable.asMutable(projectDetail, { deep: true });
    const projectUnits = (projectDetailTab.projectUnits) ? Immutable.asMutable(projectDetailTab.projectUnits, { deep: true }) : null;
    let projectUnitIndex = -1;
    let pictureIndex = -1;
    let currentProjectUnit = null;

    if (!pictureType || pictureId == null || pictureId === 0) {
        return projectDetail;
    }

    switch (pictureType) {
        case 'project-gallery':
            const index = R.findIndex(R.propEq('id', pictureId))(projectDetailTab.projectGalleries);
            const currentProjectGalleries = Immutable.asMutable(projectDetailTab.projectGalleries[index], { deep: true });
            currentProjectGalleries.title = title2Change;
            projectDetailTab.projectGalleries[index] = currentProjectGalleries;
            return projectDetailTab;
        case 'unit-floorplan':
            for (let i = 0; i <= projectUnits.length; i++) {
                pictureIndex = R.findIndex(R.propEq('id', pictureId))(projectDetailTab.projectUnits[i].floorPlanPictures);
                if (pictureIndex !== -1) {
                    projectUnitIndex = i;
                    break;
                }
            }
            if (projectUnitIndex === -1 || pictureIndex === -1) {
                break;
            }
            currentProjectUnit = Immutable.asMutable(projectUnits[projectUnitIndex], { deep: true });
            const currentFloorPlanPictures = Immutable.asMutable(currentProjectUnit.floorPlanPictures[pictureIndex], { deep: true });
            currentFloorPlanPictures.title = title2Change;
            currentProjectUnit.floorPlanPictures[pictureIndex] = currentFloorPlanPictures;
            projectUnits[projectUnitIndex] = currentProjectUnit;
            projectDetailTab.projectUnits = projectUnits;
            return projectDetailTab;
        case 'unit-gallery':
            for (let i = 0; i <= projectUnits.length; i++) {
                pictureIndex = R.findIndex(R.propEq('id', pictureId))(projectDetailTab.projectUnits[i].galleryPictures);
                if (pictureIndex !== -1) {
                    projectUnitIndex = i;
                    break;
                }
            }
            if (projectUnitIndex === -1 || pictureIndex === -1) {
                break;
            }
            currentProjectUnit = Immutable.asMutable(projectUnits[projectUnitIndex], { deep: true });
            const currentGalleryPictures = Immutable.asMutable(currentProjectUnit.galleryPictures[pictureIndex], { deep: true });
            currentGalleryPictures.title = title2Change;
            currentProjectUnit.galleryPictures[pictureIndex] = currentGalleryPictures;
            projectUnits[projectUnitIndex] = currentProjectUnit;
            projectDetailTab.projectUnits = projectUnits;
            return projectDetailTab;
        default:
            break;
    }
}

export function generateRandom() {
    return Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
}

export function generateRandomNegativeNumber() {
    return -Math.abs(Math.floor(100000 + Math.random() * 900000));
}

export function getTableMobileView(tableData, exceptProps, context) {
    const data: mblViewTables = { tables: [] };
    tableData.map((item) => {
        const table: mblViewTable = { rows: [] };
        Object.keys(item).forEach((key) => {
            if (!R.contains(key, exceptProps)) {
                const keyIntl = getIntlIdBykey(key, context);
                if (keyIntl != null) {
                    table.rows.push({ column: keyIntl, value: item[key] });
                }
                else {
                    table.rows.push({ column: key, value: item[key] });
                }
            }
        });
        data.tables.push(table);
        return;
    });
    return data;
}

// PROVINCE, DISTRICT, AREA changed method

export function getProvinces(countryCode, provinces) {
    return R.filter((province) => {
        if (province.countryCode === countryCode) {
            return true;
        }
        else {
            return false;
        }
    }, provinces);
}

export function getDistricts(provinceCode, districts) {
    return R.filter((district) => {
        if (district.regionCode === provinceCode) {
            return true;
        }
        else {
            return false;
        }
    }, districts);
}

export function getAreas(districtCode, provinceCode, areas) {
    return R.filter((area) => {
        if (area.townId.toString() === districtCode.toString()
            && area.regionCode.toString() === provinceCode.toString()) {
            return true;
        }
        else {
            return false;
        }
    }, areas);
}

function getIntlIdBykey(key, context) {
    if (context == null) { return null; }
    switch (key) {
        case 'title':
            return context.intl.formatMessage({ id: 'commission.title.property' });
        case 'type':
            return context.intl.formatMessage({ id: 'type' });
        case 'status':
            return context.intl.formatMessage({ id: 'projectDetail.dropdown.status' });
        case 'proppertyName':
            return context.intl.formatMessage({ id: 'commission.title.property' });
        case 'agentName':
            return context.intl.formatMessage({ id: 'commission.title.agentName' });
        case 'commission':
            return context.intl.formatMessage({ id: 'commission.title.commission' });
        case 'dueDate':
            return context.intl.formatMessage({ id: 'commission.title.dueDate' });
        case 'customerName':
            return context.intl.formatMessage({ id: 'customer' });
        case 'description':
            return context.intl.formatMessage({ id: 'description' });
        case 'Status':
            return context.intl.formatMessage({ id: 'projectDetail.dropdown.status' });
        case 'source':
            return context.intl.formatMessage({ id: 'enquiry.source' });
        case 'memo':
            return context.intl.formatMessage({ id: 'enquiry.memo' });
        default:
            break;
    }
    return null;
}

export const dummyRequest = ({ file, onSuccess }) => {
    setTimeout(() => {
        onSuccess('ok');
    }, 0);
};

export function getCurrentCulture() {
    const language = getStateItem('Language', 'language');
    return (language) ? language.rfc3066 : AppConfig.region;
}

export function castStringToNumber(val) {
    const thousandSeparator = (AppConfig.region === 'is-IS') ? '.' : ',';
    const decimalSeparator = (AppConfig.region === 'is-IS') ? ',' : '.';
    let newVal = val;
    if ((val) && val !== undefined) {
        newVal = val.toString().replace(new RegExp(thousandSeparator, 'g'), '').replace(decimalSeparator, '.');

    } else {
        newVal = null;
    }
    return newVal;
}

export function checkAllJsonItemsIsNull(jsonItems) {
    if (!jsonItems || jsonItems.length <= 0) { return false; }
    let valid = false;
    for (const key in jsonItems) {
        if (jsonItems.hasOwnProperty(key)) {
            if (jsonItems[key] && jsonItems[key].trim().length >= 0) {
                valid = true;
            }
        }
    }
    return valid;
}

export function validateEmail(inputValue) {
    if (!inputValue) { return false; }
    const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(inputValue).toLowerCase());
}

export function getColorCodeByCategory(category, calendarCategories: ICalendarCategory[]): ICalendarCategory {
    const colorCode = R.find(R.propEq('category', category))(calendarCategories);
    return colorCode;
}

export function getRiaNganWaFromLandSize(landSize) {
    if (landSize == null) {
        return;
    }
    const rai = 1600;
    const ngan = 400;
    const sqw = 4;
    // tsline:disable-next-line
    let areaRai = 0;
    let areaNgan = 0;
    let areaWa = 0;
    // convert rai
    areaRai = Math.floor((landSize) / rai);
    // convert ngan
    areaNgan = Math.floor(Math.round((landSize) % rai) / ngan);
    // convert wa
    areaWa = Math.round((((landSize) % rai) % ngan) / sqw);
    const THLandSize = { rai: areaRai, ngan: areaNgan, wa: areaWa };
    return THLandSize;
}

export function calculateLandSizeFromRaiNganWa(rai, ngan, wa) {
    rai = 1600 * rai;
    ngan = 400 * ngan;
    wa = 4 * wa;
    return rai + ngan + wa;
}

export function getCurrentUserId() {
    const userprofile = getStateItem('SagaAuth', 'userProfileResponse');
    return (userprofile) ? userprofile.id : '';
}

export function checkDateIsMinValue(inputDate) {
    const minDate = moment('0001-01-01', 'YYYY-MM-DD');
    const dateInput = moment(inputDate, 'YYYY-MM-DD HH:mm:ss');
    if (minDate.day() === dateInput.day() && minDate.month() === dateInput.month() && minDate.year() === dateInput.year()) {
        return true;
    }
    return false;
}

export function metaInfoSelectFilterOption(input, option) {
    if (!option || option === undefined) { return false; }
    // if option is not a string type then return false
    if (typeof option.props.children !== 'string') { return false; }
    return option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0;
}

export function isValueInDataSource(value, source, propName) {
    if (!value || value === undefined || !source || source === undefined || !propName || propName === undefined) { return false; }
    const result = R.find(R.propEq(propName, value))(source);
    return (result === undefined || !result) ? false : true;
}

export function isRenderAsIFrame() {
    try {
        return window.self !== window.top;
    } catch (error) {
        return true;
    }
}

export function validateBuyerInformation(buyerinfo) {
    if (buyerinfo) {
        let isValid = true;
        // validate there's new contact but not input name
        const index = R.findIndex(R.propEq('id', '00000000-0000-0000-0000-000000000000')
            && (R.propEq('name', '') || R.propEq('name', undefined) || R.propEq('name', null)))(buyerinfo);
        if (index !== -1) { isValid = false; }
        // validate limit characters
        R.forEach((item) => {
            // address
            if (item.address && item.address.length > 100) { isValid = false; }
            // home phone
            if (item.homePhone && item.homePhone.length > 100) { isValid = false; }
            // work phone
            if (item.workPhone && item.workPhone.length > 100) { isValid = false; }
            // mobile phone
            if (item.mobilePhone && item.mobilePhone.length > 100) { isValid = false; }
            // validate email
            if (item.email && !validateEmail(item.email)) { isValid = false; }
        }, buyerinfo);
        return isValid;
    }
    return true;
}

export function replaceUnnecessaryCharacters(inputData) {
    if (!inputData || inputData === undefined || inputData.length === 0) { return; }
    return inputData.replace(/(?:\r\n|\r|\n)/g, '');
}

export function moveItemInArray(from, to, arr) {
    const element = arr[from];
    arr.splice(from, 1);
    arr.splice(to, 0, element);
    return arr;
}

export function setDefaultTime(dateMoment) { // type moment
    if (dateMoment && dateMoment !== null) {
        const defaultTime = moment('12:00', 'HH:mm');
        dateMoment.set({
            hour: defaultTime.get('hour'),
            minute: defaultTime.get('minute'),
            second: defaultTime.get('second')
        });
    }
    return dateMoment;
}

export function sortByNumber(a, b, key) {
    const valueA = (a[key]) ? +a[key] : 0;
    const valueB = (b[key]) ? +b[key] : 0;
    // return valueA - valueB;
    if (valueA < valueB) { return -1; }
    if (valueA > valueB) { return 1; }
    return 0;
}

export function sortByAlphabet(a, b, key) {
    const valueA = (a[key]) ? (key) ? a[key].toLowerCase().trim() : a : '';
    const valueB = (b[key]) ? (key) ? b[key].toLowerCase().trim() : b : '';
    if (valueA < valueB) { return -1; }
    if (valueA > valueB) { return 1; }
    return 0;
}

export function sortByBoolen(a, b, key) {
    const valueA = (a[key]) ? (key) ? a[key] : a : false;
    const valueB = (b[key]) ? (key) ? b[key] : b : false;
    return (valueA === valueB) ? 0 : valueA ? -1 : 1;
}

export function sortByDate(a, b, key, format) {
    const dateA = (a[key]) ? moment(a[key], format).toDate() : moment('0001-01-01', 'YYYY-MM-DD');
    const dateB = (b[key]) ? moment(b[key], format).toDate() : moment('0001-01-01', 'YYYY-MM-DD');
    return dateA.valueOf() - dateB.valueOf();
}

export function convertDataToIDropdownData(source, keyId, keyName): IDropdownData[] {
    if (!source || source === undefined || source.length === 0) { return []; }
    const result: IDropdownData[] = [];
    source.forEach((item) => {
        result.push({ id: item[keyId], name: item[keyName] });
    });
    return result;
}

export function getPropertiesByType(type: EPropertyListType, data: Property[], userId: string, agentIsolation: boolean, userType: string) {
    let result: Property[] = [];
    if (!data || data === undefined || data.length === 0) { return result; }
    // in case office set userisolation = true and user role is 'sale_agent' then use only my properties data
    let masterData = data;
    if (agentIsolation && userType === 'sale_agent') {
        // filter data to only this agent data
        masterData = R.filter((item: Property) => {
            return item.salesRepresentativeId === userId ? true : false;
        }, data);
    }
    switch (type) {
        case EPropertyListType.MYPROPERTY:
            result = R.filter((item: Property) => {
                return (item.salesRepresentativeId === userId && !item.inStorage) ? true : false;
            }, masterData);
            break;
        case EPropertyListType.ALLPROPERTY:
            result = R.filter((item: Property) => {
                return (!item.inStorage) ? true : false;
            }, masterData);
            break;
        case EPropertyListType.ARCHIVEPROPERTY:
            result = R.filter((item: Property) => {
                return item.inStorage ? true : false;
            }, masterData);
            break;
        case EPropertyListType.OFFERPROPERTY:
            result = R.filter((item: Property) => {
                return (item.hasOffer && !item.inStorage) ? true : false;
            }, masterData);
            break;
        case EPropertyListType.CONTRACTPROPERTY:
            result = R.filter((item: Property) => {
                return (item.hasContract && !item.inStorage) ? true : false;
            }, masterData);
            break;
        case EPropertyListType.DEEDPROPERTY:
            result = R.filter((item: Property) => {
                return (item.hasDeed && !item.inStorage) ? true : false;
            }, masterData);
            break;
    }
    // filter by quick & advance search

    return result;
}

export function propertyListAdvanceSearchLogic(allData: Property[], advanceSearch: IAdvanceSearchOutput, portalList: SelectedPortalProperty[]) {
    if (advanceSearch === undefined || !advanceSearch) { return allData; }
    let filterData = allData;
    // province
    if (advanceSearch.province) {
        filterData = R.filter((item: Property) => {
            if (item.province !== undefined && item.province && item.province === advanceSearch.province) {
                return true;
            }
            return false;
        }, filterData);
    }
    // district
    if (advanceSearch.district) {
        filterData = R.filter((item: Property) => {
            if (item.district !== undefined && item.district && item.district === advanceSearch.district) {
                return true;
            }
            return false;
        }, filterData);
    }
    // area
    if (advanceSearch.area) {
        filterData = R.filter((item: Property) => {
            if (item.area !== undefined && item.area && item.area === advanceSearch.area) {
                return true;
            }
            return false;
        }, filterData);
    }
    // zone
    if (advanceSearch.zone) {
        filterData = R.filter((item: Property) => {
            if (item.zoneId !== undefined && item.zoneId && item.zoneId === advanceSearch.zone) {
                return true;
            }
            return false;
        }, filterData);
    }
    // projectname
    if (advanceSearch.projectNames && advanceSearch.projectNames.length > 0) {
        filterData = R.filter((item: Property) => {
            if (item.projectName !== undefined && item.projectName && R.contains(item.projectName, advanceSearch.projectNames)) {
                return true;
            }
            return false;
        }, filterData);
    }
    // property types
    if (advanceSearch.projectTypes && advanceSearch.projectTypes.length > 0) {
        filterData = R.filter((item: Property) => {
            if (item.propertyTypeIds !== undefined && item.propertyTypeIds && (item.propertyTypeIds.some(i => advanceSearch.projectTypes.indexOf(i) >= 0))) {
                return true;
            }
            return false;
        }, filterData);
    }
    // property statuses
    if (advanceSearch.status && advanceSearch.status.length > 0) {
        filterData = R.filter((item: Property) => {
            if (item.propertyStatusId !== undefined && item.propertyStatusId && R.contains(item.propertyStatusId, advanceSearch.status)) {
                return true;
            }
            return false;
        }, filterData);
    }
    // sale/rent
    if (advanceSearch.saleOrRent) {
        filterData = R.filter((item: Property) => {
            if (item.saleOrRent !== undefined && item.saleOrRent && item.saleOrRent === advanceSearch.saleOrRent) {
                return true;
            }
            return false;
        }, filterData);
    }
    // size
    if (advanceSearch.sizeFrom && advanceSearch.sizeTo) {
        filterData = R.filter((item: Property) => {
            if (item.size !== undefined && item.size && (item.size >= advanceSearch.sizeFrom && item.size <= advanceSearch.sizeTo)) {
                return true;
            }
            return false;
        }, filterData);
    }
    else if (advanceSearch.sizeFrom) {
        filterData = R.filter((item: Property) => {
            if (item.size !== undefined && item.size && item.size >= advanceSearch.sizeFrom) {
                return true;
            }
            return false;
        }, filterData);
    }
    else if (advanceSearch.sizeTo) {
        filterData = R.filter((item: Property) => {
            if (item.size !== undefined && item.size && item.size <= advanceSearch.sizeTo) {
                return true;
            }
            return false;
        }, filterData);
    }
    // bedrooms
    if (advanceSearch.bedroomFrom && advanceSearch.bedroomTo) {
        filterData = R.filter((item: Property) => {
            if (item.bedRoom !== undefined && item.bedRoom && (item.bedRoom >= advanceSearch.bedroomFrom && item.bedRoom <= advanceSearch.bedroomTo)) {
                return true;
            }
            return false;
        }, filterData);
    }
    else if (advanceSearch.bedroomFrom) {
        filterData = R.filter((item: Property) => {
            if (item.bedRoom !== undefined && item.bedRoom && item.bedRoom >= advanceSearch.bedroomFrom) {
                return true;
            }
            return false;
        }, filterData);
    }
    else if (advanceSearch.bedroomTo) {
        filterData = R.filter((item: Property) => {
            if (item.bedRoom !== undefined && item.bedRoom && item.bedRoom <= advanceSearch.bedroomTo) {
                return true;
            }
            return false;
        }, filterData);
    }
    // bathrooms
    if (advanceSearch.bathroomFrom && advanceSearch.bathroomTo) {
        filterData = R.filter((item: Property) => {
            if (item.bathRoom !== undefined && item.bathRoom && (item.bathRoom >= advanceSearch.bathroomFrom && item.bathRoom <= advanceSearch.bathroomTo)) {
                return true;
            }
            return false;
        }, filterData);
    }
    else if (advanceSearch.bathroomFrom) {
        filterData = R.filter((item: Property) => {
            if (item.bathRoom !== undefined && item.bathRoom && item.bathRoom >= advanceSearch.bathroomFrom) {
                return true;
            }
            return false;
        }, filterData);
    }
    else if (advanceSearch.bathroomTo) {
        filterData = R.filter((item: Property) => {
            if (item.bathRoom !== undefined && item.bathRoom && item.bathRoom <= advanceSearch.bathroomFrom) {
                return true;
            }
            return false;
        }, filterData);
    }
    // total rooms
    if (advanceSearch.totalroomFrom && advanceSearch.totalroomTo) {
        filterData = R.filter((item: Property) => {
            if (item.totalRooms !== undefined && item.totalRooms && (item.totalRooms >= advanceSearch.totalroomFrom && item.totalRooms <= advanceSearch.totalroomTo)) {
                return true;
            }
            return false;
        }, filterData);
    }
    else if (advanceSearch.totalroomFrom) {
        filterData = R.filter((item: Property) => {
            if (item.totalRooms !== undefined && item.totalRooms && item.totalRooms >= advanceSearch.totalroomFrom) {
                return true;
            }
            return false;
        }, filterData);
    }
    else if (advanceSearch.totalroomTo) {
        filterData = R.filter((item: Property) => {
            if (item.totalRooms !== undefined && item.totalRooms && item.totalRooms <= advanceSearch.totalroomTo) {
                return true;
            }
            return false;
        }, filterData);
    }
    // price
    if (advanceSearch.priceFrom && advanceSearch.priceTo) {
        filterData = R.filter((item: Property) => {
            if (item.price !== undefined && item.price && (item.price >= advanceSearch.priceFrom && item.price <= advanceSearch.priceTo)) {
                return true;
            }
            return false;
        }, filterData);
    }
    else if (advanceSearch.priceFrom) {
        filterData = R.filter((item: Property) => {
            if (item.price !== undefined && item.price && item.price >= advanceSearch.priceFrom) {
                return true;
            }
            return false;
        }, filterData);
    }
    else if (advanceSearch.priceTo) {
        filterData = R.filter((item: Property) => {
            if (item.price !== undefined && item.price && item.price <= advanceSearch.priceTo) {
                return true;
            }
            return false;
        }, filterData);
    }
    // featured
    if (advanceSearch.feature) {
        filterData = R.filter((item: Property) => {
            if (item.isFeatured !== undefined && item.isFeatured && item.isFeatured.toString() === advanceSearch.feature) {
                return true;
            }
            return false;
        }, filterData);
    }
    // onweb
    if (advanceSearch.onWeb) {
        filterData = R.filter((item: Property) => {
            if (item.onWebStatus !== undefined && item.onWebStatus !== null && item.onWebStatus.toString() === advanceSearch.onWeb) {
                return true;
            }
            return false;
        }, filterData);
    }

    // property portal
    if ((advanceSearch.onWeb) && advanceSearch.onWeb.toLowerCase() === 'true') {
        if (advanceSearch.portalIds && advanceSearch.portalIds.length > 0) {
            if (!(R.contains(null, advanceSearch.portalIds))) {
                filterData = R.filter((item: Property) => {
                    const senderIds = [];
                    R.filter((portalProp: SelectedPortalProperty) => {
                        if (item.propertyId === portalProp.propertyId) {
                            senderIds.push(portalProp.portalSenderId);
                        }
                    }, portalList);

                    return R.any((filter) => R.contains(filter, senderIds), advanceSearch.portalIds);
                }, filterData);
            }
        } else {
            filterData = R.filter((item: Property) => {
                const senderIds = [];
                R.filter((portalProp: SelectedPortalProperty) => {
                    if (item.propertyId === portalProp.propertyId) {
                        senderIds.push(portalProp.portalSenderId);
                    }
                }, portalList);

                return senderIds === null || senderIds.length === 0;
            }, filterData);

        }
    }

    // modified on
    if (advanceSearch.modifiedDateFrom && advanceSearch.modifedDateTo) {
        filterData = R.filter((item: Property) => {
            if (!item.modifiedOn) { return false; }
            return moment(item.modifiedOn, 'YYYY-MM-DD HH:mm:ss').isBetween(advanceSearch.modifiedDateFrom, advanceSearch.modifedDateTo);
        }, filterData);
    }
    else if (advanceSearch.modifiedDateFrom && !advanceSearch.modifedDateTo) {
        filterData = R.filter((item: Property) => {
            const itemDate = moment(item.modifiedOn, 'YYYY-MM-DD HH:mm:ss');
            return itemDate.isSameOrAfter(advanceSearch.modifiedDateFrom);
        }, filterData);
    }
    else if (advanceSearch.modifedDateTo && !advanceSearch.modifiedDateFrom) {
        filterData = R.filter((item: Property) => {
            const itemDate = moment(item.modifiedOn, 'YYYY-MM-DD HH:mm:ss');
            return itemDate.isSameOrBefore(advanceSearch.modifedDateTo);
        }, filterData);
    }
    return filterData;
}

export function getLocalStringCode(): string {
    return (AppConfig.region === 'is-IS') ? 'de-DE' : AppConfig.region;
}

export function checkDataIsInSource(data, source, key): boolean {
    if (data && source) {
        let value = null;
        if (key) {
            value = R.find(R.propEq(key, data))(source);
        }
        else {
            value = R.find(R.propEq(key, data))(source);
        }
        return (value && value !== undefined) ? true : false;
    }
    return false;
}

export function formatSSN(ssn, region) {
    if (!ssn || ssn === undefined) { return ''; }
    switch (region) {
        case 'is-IS':
            ssn = ssn.length > 10 ? ssn.substr(0, 10) : ssn;
            return ssn.replace(/^(.{6})(.{4})$/, '$1-$2');
        case 'th-TH':
            return ssn.replace(/^(.{1})(.{4})(.{5})(.{2})(.{1})$/, '$1-$2-$3-$4-$5');
        default:
            return ssn;
    }
}

export function formatISPropertyId(propertyId) {
    if (!propertyId || propertyId === undefined) { return ''; }
    return propertyId.replace(/^(.{3})(.{4})$/, '$1-$2');
}

export function convertPictureDetailToGalleryImage(pictureDetail: PictureDetail): IGalleryImage {
    if (pictureDetail == null || pictureDetail === undefined) { return null; }
    return {
        src: pictureDetail.fileName,
        thumbnail: pictureDetail.fileName,
        thumbnailWidth: 137,
        thumbnailHeight: 150,
        title: pictureDetail.title,
        id: pictureDetail.id,
        isSelected: pictureDetail.isSelected,
        index: pictureDetail.index
    };
}

export function convertPictureDetailsToGalleryImages(pictureDetails: PictureDetail[]): IGalleryImage[] {
    if (pictureDetails == null || pictureDetails === undefined || pictureDetails.length === 0) { return []; }
    return pictureDetails.map((item) => {
        return convertPictureDetailToGalleryImage(item);
    });
}

export function convertGalleryImagesToPictureDetails(galleryImages: IGalleryImage[]): PictureDetail[] {
    if (galleryImages == null || galleryImages === undefined || galleryImages.length === 0) { return []; }
    return galleryImages.map((item) => {
        return convertGalleryImageToPictureDetail(item);
    });
}

export function convertGalleryImageToPictureDetail(galleryImage: IGalleryImage): PictureDetail {
    if (galleryImage == null || galleryImage === undefined) { return null; }
    return {
        id: galleryImage.id,
        fileName: galleryImage.src,
        index: galleryImage.index,
        isSelected: galleryImage.isSelected,
        title: galleryImage.title
    };
}

export function convertVideoLinksToGalleryImages(videos: VideoLink[]): IGalleryImage[] {
    if (videos == null || videos === undefined) { return []; }
    return videos.map((item) => {
        return convertVideoLinkToGalleryImages(item);
    });
}

export function convertVideoLinkToGalleryImages(video: VideoLink): IGalleryImage {
    if (video == null || video === undefined) { return null; }
    return {
        src: video.url,
        id: video.id,
        title: video.title,
        index: video.sequence,
        thumbnail: getVideoCoverImage(video.url), // should be youtube image url
    };
}

export function convertPropertyFilesToGalleryImages(files: PropertyFile[]): IGalleryImage[] {
    if (files == null || files === undefined) { return []; }
    return files.map((item) => {
        return convertPropertyFileToGalleryImages(item);
    });
}

export function convertPropertyFileToGalleryImages(file: PropertyFile): IGalleryImage {
    if (file == null || file === undefined) { return null; }
    return {
        src: file.fileContent,
        id: file.id,
        title: file.fileName,
        thumbnail: file.thumbnail, // should be youtube image url
    };
}

export function isYoutubeVideo(url) {
    const p = /^(?:https?:\/\/)?(?:m\.|www\.)?(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|watch\?.+&v=))((\w|-){11})(?:\S+)?$/;
    const isyouTubeUrl = url.match(p);
    return isyouTubeUrl;
}

export function getYoutubeId(url) {
    return url.split(/v\/|v=|youtu\.be\//)[1].split(/[?&]/)[0];
}

export function getYoutubeCoverImage(url) {
    const youtubeId = getYoutubeId(url);
    return 'http://img.youtube.com/vi/' + youtubeId + '/0.jpg';
}

export function getVideoCoverImage(url) {
    if (url && isYoutubeVideo(url)) {
        return getYoutubeCoverImage(url);
    }
    return require('../image/no-images-placeholder.png'); // default cover image
}

export function replaceToYoutubeStandardUrl(url) {
    const youtubeId = getYoutubeId(url);
    return `https://www.youtube.com/watch?v=${youtubeId}`;
}

export function getThousandSeparator() {
    return (AppConfig.region === 'is-IS') ? '.' : ',';
}

export function getDecimalSeparator() {
    return (AppConfig.region === 'is-IS') ? ',' : '.';
}

export function getFormatDate() {
    return AppConfig.region === 'is-IS' ? 'DD.MM.YYYY' : 'DD/MM/YYYY';
}

export function getFormatDateTime() {
    return AppConfig.region === 'is-IS' ? 'DD.MM.YYYY HH:mm:ss' : 'DD/MM/YYYY HH:mm:ss';
}

export function getPlace(address, province, district, area) {
    let place = '';
    if (address !== null && address !== '') {
        place = place + ' ' + address;
    }
    if (province !== null && province !== '') {
        place = place + ' ' + province;
    }
    if (district !== null && district !== '') {
        place = place + ' ' + district;
    }
    if (area !== null && area !== '') {
        place = place + ' ' + area;
    }
    return place;
}

export function convertTrueFlaseStringToBoolean(data) {
    return (data === 'true') ? true : false;
}

export function getProvinceFromPostalAddress(postalAddress) {
    if (!postalAddress || postalAddress === undefined) { return ''; }
    const region = AppConfig.region;
    let provinceCode = null;
    if (region === 'is-IS') {
        provinceCode = postalAddress.split('-')[0].trim();
        return (provinceCode) ? postalAddress.replace(provinceCode, '').trim() : null;
    }
    else {
        provinceCode = postalAddress.split(' ')[0].trim();
        return (provinceCode) ? postalAddress.replace(provinceCode, '').trim() : null;
    }
}

export function getDistrictFromPostalAddress2(postalAddress2) {
    if (!postalAddress2 || postalAddress2 === undefined) { return ''; }
    const districtCode = postalAddress2.split(' ')[0].trim();
    return (districtCode) ? postalAddress2.replace(districtCode, '').trim() : null;
}

export function getAreaFromPostalAddress(postalAddress) {
    if (!postalAddress || postalAddress === undefined) { return ''; }
    const areaCode = postalAddress.split(' ')[0].trim();
    return (areaCode) ? postalAddress.replace(areaCode, '').trim() : null;
}

export function isSelectedPictures(propertyPictures: IGalleryImage[]) {
    if (!propertyPictures || propertyPictures === undefined) { return false; }
    for (let i = 0; i < propertyPictures.length; i++) {
        if (propertyPictures[i].isSelected) {
            return true;
        }
    }
    return false;
}

export function rotateImage(imgSrc, isClockwise, callback) {
    const canvas = document.getElementById('tempCanvas') as HTMLCanvasElement;
    const context = canvas.getContext('2d');
    let image = new Image();
    image.crossOrigin = 'anonymous';
    image.src = (imgSrc.indexOf('https') > -1) ? imgSrc.replace(/^https:\/\//i, 'http://') : imgSrc;
    image.onload = () => {
        canvas.width = image.height;
        canvas.height = image.width;
        context.save();
        if (isClockwise) {
            context.rotate(90 * Math.PI / 180);
            context.translate(0, -canvas.width);
        }
        else {
            context.rotate(-90 * Math.PI / 180);
            context.translate(-canvas.height, 0);
        }
        context.drawImage(image, 0, 0);
        context.restore();
        callback(canvas.toDataURL());
        image = null;
    };
}

export function parseStringToNumber(value) {
    let parseValue = '';
    if (value && value !== null) {
        if (AppConfig.region === 'is-IS') {
            parseValue = value.toString().replace('.', '');
        }
        else {
            parseValue = value.toString().replace(',', '');
        }
    }
    return +parseValue;
}

export function validateNumberLength(rule, value, callback, len, formatMessage) {
    if (value === null || value === undefined) { return callback(); }
    const message = getLimitLengthMessage(len, formatMessage);
    if (Number.isInteger(value)) {
        if (value && (+value).toString().length > len) {
            return callback(message);
        }
        return callback();
    }
    else {
        let parseValue = '';
        if (AppConfig.region === 'is-IS') {
            parseValue = value.replace(/./g, '');
        }
        else {
            parseValue = value.replace(/,/g, '');
        }
        if (value && +(parseValue).toString().length > len) {
            return callback(message);
        }
        return callback();
    }
}

export function getLimitLengthMessage(limit, formatMessage) {
    return `${formatMessage({ id: 'propertyDetail.error.limitLength' })} ${limit} ${formatMessage({ id: 'propertyDetail.error.character' })}`;
}

export function checkIsDate(data) {
    if (data == null || data === undefined) { return false; }
    return data instanceof Date;
}

export function checkIsNumber(data) {
    if (data == null || data === undefined) { return false; }
    return typeof data === 'number';
}

export function checkIsBoolean(data) {
    if (data == null) { return false; }
    return typeof data === 'boolean';
}


// WEBPACK FOOTER //
// ./src/helpers/utility.ts